export default __webpack_public_path__ + "static/media/icons8-github.614eff31.svg";